/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_mode_rpm_to_rcf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPM → RCF`)
};

const es_gf_mode_rpm_to_rcf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPM → RCF`)
};

const de_gf_mode_rpm_to_rcf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPM → RCF`)
};

const nl_gf_mode_rpm_to_rcf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPM → RCF`)
};

const fr_gf_mode_rpm_to_rcf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPM → RCF`)
};

const it_gf_mode_rpm_to_rcf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPM → RCF`)
};

const pt_br2_gf_mode_rpm_to_rcf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPM → RCF`)
};

const pt_gf_mode_rpm_to_rcf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPM → RCF`)
};

const ja_gf_mode_rpm_to_rcf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPM → RCF`)
};

const zh_gf_mode_rpm_to_rcf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPM → RCF`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_mode_rpm_to_rcf = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_mode_rpm_to_rcf(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_mode_rpm_to_rcf", locale)
	if (locale === "en") return en_gf_mode_rpm_to_rcf(inputs)
	if (locale === "es") return es_gf_mode_rpm_to_rcf(inputs)
	if (locale === "de") return de_gf_mode_rpm_to_rcf(inputs)
	if (locale === "nl") return nl_gf_mode_rpm_to_rcf(inputs)
	if (locale === "fr") return fr_gf_mode_rpm_to_rcf(inputs)
	if (locale === "it") return it_gf_mode_rpm_to_rcf(inputs)
	if (locale === "pt-BR") return pt_br2_gf_mode_rpm_to_rcf(inputs)
	if (locale === "pt") return pt_gf_mode_rpm_to_rcf(inputs)
	if (locale === "ja") return ja_gf_mode_rpm_to_rcf(inputs)
	return zh_gf_mode_rpm_to_rcf(inputs)
};